export function submitPayoutV3(send) {
  return (body, contentType = 'application/json', ...args) =>
    send(
      {
        path: '/v3/payouts',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: contentType,
      },
      ...args
    );
}
